(function(){
  if (window.__nycQuickAdd) return;
  window.__nycQuickAdd = true;
  var root = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
  document.addEventListener('submit', function(event){
    var form = event.target && event.target.closest ? event.target.closest('form[data-nyc-quick-add]') : null;
    if (!form) return;
    event.preventDefault();
    var button = form.querySelector('button[type=submit]');
    if (!button || button.disabled) return;
    var label = button.textContent;
    button.disabled = true;
    button.textContent = button.dataset.adding || 'Añadiendo…';
    fetch(root + 'cart/add.js', { method: 'POST', body: new FormData(form), credentials: 'same-origin', headers: { Accept: 'application/json' } })
      .then(function(response){
        return response.json().then(function(data){
          if (!response.ok) throw new Error(data.description || data.message || 'Error');
          return data;
        });
      })
      .then(function(){ button.textContent = button.dataset.added || 'Añadido ✓'; })
      .catch(function(){ button.textContent = 'No se pudo añadir'; })
      .then(function(){ setTimeout(function(){ button.disabled = false; button.textContent = label; }, 1800); });
  });
})();
